// extracted by mini-css-extract-plugin
export default {"uploadRes":"QuestionPanel_uploadRes__F5nsG","formControl":"QuestionPanel_formControl__rZ7JU","lastFiveRes":"QuestionPanel_lastFiveRes__1nupo"};